var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.8.137,15,2.062,12.45.137a.8.8,0,0,0-.9,0L9,2.062,6.45.137a.8.8,0,0,0-.9,0L3,2.062,1.2.137A.756.756,0,0,0,0,.687V21.31a.756.756,0,0,0,1.2.55L3,19.935l2.55,1.925a.8.8,0,0,0,.9,0L9,19.935l2.55,1.925a.8.8,0,0,0,.9,0L15,19.935l1.8,1.925a.757.757,0,0,0,1.2-.55V.687a.756.756,0,0,0-1.2-.55ZM15,15.466a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,15.466v-.687a.361.361,0,0,1,.375-.344h11.25a.361.361,0,0,1,.375.344Zm0-4.125a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,11.342v-.687a.361.361,0,0,1,.375-.344h11.25a.361.361,0,0,1,.375.344Zm0-4.125a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,7.217V6.53a.361.361,0,0,1,.375-.344h11.25A.361.361,0,0,1,15,6.53Z",
    transform: "translate(0 0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.ab3b80324927823b9e2ccda1c68e7fb3.svg";
export { ForwardRef as ReactComponent };